var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    x: 0,
    y: 0,
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M26.511 12.004 6.233.463C4.082-.765 1.889.578 1.889 2.993v24.093c0 2.046 1.332 2.979 2.57 2.979.583 0 1.177-.184 1.767-.543l20.369-12.468c1.024-.629 1.599-1.56 1.581-2.555-.017-.996-.623-1.906-1.665-2.495zm-1.281 2.823L4.862 27.292a1.297 1.297 0 0 1-.319.147 1.354 1.354 0 0 1-.04-.353V2.994c0-.248.045-.373.045-.404.08.005.22.046.396.146l20.275 11.541c.25.143.324.267.348.24-.013.034-.098.161-.337.31z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.ecd3b0cc235916890f6f0166d8656267.svg";
export { ForwardRef as ReactComponent };